module.exports = __webpack_public_path__ + "img/image-5.c1014ae6.jpg";